import React from 'react'

const PriceLists = () => {
  return (
    <div>PriceLists</div>
  )
}

export default PriceLists